import { render } from "./LeaveEntitlements.vue?vue&type=template&id=45a03298"
import script from "./LeaveEntitlements.vue?vue&type=script&lang=js"
export * from "./LeaveEntitlements.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp3\\htdocs\\a\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__